import { connect } from 'react-redux'
import { IGlobalState } from '../../Root/store/appReducer'
import Chat from './Chat'
import { userDtoSelector, userCompaniesSelector } from '../Settings/store/SettingsSelectors'

const mapStateToProps = (state: IGlobalState, ownProps: any) => ({
  channelKind: ownProps.match.params.channelKind || null,
  channelId: ownProps.match.params.channelId || null,
  userDto: userDtoSelector(state),
  userCompanies: userCompaniesSelector(state),
})

export default connect(mapStateToProps)(Chat)
